angular.module(NgAppName).service('crResourcesService', ['$resource', '$q', function($resource, $q){

	/**
	 * Main function to use to get data
	 * @param  {String} url Url to call
	 * @return {Object}     The resource object
	 */
	this.get = function(url, data){

		var res = $resource(url, {}, {
			get: {
				method: 'GET',
				headers: {
					'X-Requested-With':	'XMLHttpRequest'
				},
				cancellable: true
			}
		});

		// define default data 
		var defaultData = {
			// type: 'json',
			// uniqueid: (new Date()).getTime()
		};

		// merge the custom data with the default data
		var finalData = angular.extend({}, defaultData, data);


		// return res.query(finalData);
		return res.get(finalData);
	};



	/**
	 * Main function to use to post data
	 * @param  {String} url Url to call
	 * @return {Object}     The resource object
	 */
	this.post2 = function(url, data){

		var res = $resource(url, {}, {
			post: {
				method: 'POST',
				headers: {
					'X-Requested-With':	'XMLHttpRequest'
				},
				cancellable: true
			}
		});

		// define default data
		var defaultData = {
			type: 'json',
			uniqueid: (new Date()).getTime()
		};

		// merge the custom data with the default data
		var finalData = angular.extend({}, defaultData, data);

		return res.post(finalData);
	};

	// /**
	//  * Main function to use to post data
	//  * @param  {String} url Url to call
	//  * @return {Object}     The resource object
	//  */
	//  this.post2 = function(url, data){

	// 	var res = $resource(url, {}, {
	// 		post: {
	// 			method: 'POST',
	// 			headers: {
	// 				'X-Requested-With':	'XMLHttpRequest'
	// 			},
	// 			cancellable: true
	// 		}
	// 	});

	// 	// define default data
	// 	var defaultData = {
	// 		type: 'json',
	// 		uniqueid: (new Date()).getTime()
	// 	};

	// 	// merge the custom data with the default data
	// 	var finalData = angular.extend({}, defaultData, data);

	// 	return res.post(finalData);
	// };

	/**
	 * Main function to use to post data
	 * @param  {String} url Url to call
	 * @return {Object}     The resource object
	 */
	this.post = function(url, data){
		var deferred = $q.defer();

		var res = $resource(url, {}, {
			post: {
				method: 'POST',
				headers: {
					'X-Requested-With':	'XMLHttpRequest'
				},
				cancellable: true
			}
		});

		// define default data
		var defaultData = {
			type: 'json',
			uniqueid: (new Date()).getTime()
		};

		// merge the custom data with the default data
		var finalData = angular.extend({}, defaultData, data);

		res.post(finalData, function(data){ //success
			deferred.resolve(data);
		}, function(response){ //failure
			deferred.reject(response);
		});
		return deferred.promise;
	};

	this.getDataObject = function(url){
		var deferred = $q.defer();

		var res = $resource(url, {type: '@type'}, {
			get: {
				method: 'GET',
				headers: {
					'X-Requested-With':	'XMLHttpRequest'
				}
			}
		});

		res.get({
			type: 'json',
			uniqueid: (new Date()).getTime()
		}, function(data){ //success
			deferred.resolve(data);
		}, function(response){ //failure
			deferred.reject(response);
		});

		return deferred.promise;
	};

	this.getDataArray = function(url){
		var deferred = $q.defer();

		// var res = $resource(url, {type: '@type'}, {
		// 	get: {
		// 		method: 'GET',
		// 		headers: {
		// 			'X-Requested-With':	'XMLHttpRequest'
		// 		}
		// 	}
		// });

		var res = $resource(url, {type: '@type'});

		res.query({
			type: 'json',
			uniqueid: (new Date()).getTime()
		}, function(data){ //success
			deferred.resolve(data);
		}, function(response){ //failure
			deferred.reject(response);
		});

		return deferred.promise;
	};
}]);
